/* eslint-disable no-extend-native */
/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import {
    createApp,
    computed,
    ref,
    reactive,
    onMounted,
} from 'vue/dist/vue.esm-bundler';

import { useStore } from 'vuex';
import { plugin, defaultConfig } from '@formkit/vue';
import { de } from '@formkit/i18n';
// import VueToast from 'vue-toast-notification';

import store from './frontendStore';
import jobfilter from './components/jobFilter.vue';
import jobapplication from './components/jobApplication.vue';

const app = createApp({
    components: {
        jobfilter,
        jobapplication,
    },
    setup() {},
});

app.use(store).use(
    plugin,
    defaultConfig({
        locales: { de },
        locale: 'de',
    })
);
// app.use(VueToast);

app.mount('#lbfFrontendApp');
